import React from 'react';
import { InappmessagesProps, fallbackImage } from '../inappmessages';
import { Picture } from '../../../elements/picture/picture';
import { BodyContent } from './bodyContent';

import styles from '../inappmessages.module.scss';

export function InappmessageFullImageText({
  data,
  onClosePopup,
}: {
  data: InappmessagesProps;
  onClosePopup: Function;
}) {
  const { imageUrl, header, message, buttons, openTarget, imageStyle } = data;
  return (
    <>
      <header className={styles.fullImageWrapper}>
        <Picture
          className={styles.fullImage}
          sizes={[{ url: imageUrl }]}
          lazyLoad={true}
          isAMP={false}
          fallback={fallbackImage}
        ></Picture>
      </header>
      <main className={styles.modalBody}>
        <BodyContent
          title={header || ''}
          description={message || ''}
          buttons={buttons}
          openTarget={openTarget}
          imageStyle={imageStyle}
          onClosePopup={onClosePopup}
          inAppMessage={data}
        />
      </main>
    </>
  );
}
